import {createContext, type ReactNode, useContext} from 'react'

import {
  type UserStreakState,
  useStreak as useStreakHook,
} from '../hooks/useStreak'

const StreakContext = createContext<UserStreakState | null>(null)

export function StreakProvider({
  children,
  role,
}: {
  children: ReactNode
  role?: 'student' | 'teacher'
}) {
  const value = useStreakHook(role)
  return (
    <StreakContext.Provider value={value}>{children}</StreakContext.Provider>
  )
}

export function useStreakContext(): UserStreakState {
  const ctx = useContext(StreakContext)
  if (!ctx)
    throw new Error('useStreakContext must be used within StreakProvider')
  return ctx
}

export {StreakContext}

export const useStreak = useStreakContext
